import {observable} from "mobx";
import {RelatorioService} from "../../../services";
import {getMensagemDeErro} from "../../../utils/functions";
import fileDownload from "../../comum/components/FileDownload";

export default class AuditoriaSubstituicaoStore {
    @observable erro;
    @observable carregando;
    @observable dados;

    constructor() {
        this.relatorioService = new RelatorioService();
    }

    filtrar = (filtro) => {
        this.carregando = true;
        this.erro = null;

        this.relatorioService.findAuditoriaSubstituicao(filtro).then(response => {
            this.dados = response.data;
            
            this.carregando = false;
        }).catch(error => {
            this.erro = getMensagemDeErro(error);
            this.carregando = false;
        });
    }

    onExportExcel = (filtro) => {
        this.carregando = true;
        this.erro = null;

        this.relatorioService.downloadAuditoriaSubstituicaoExcel(filtro).then(response => {
            fileDownload(response.data, "Auditoria substituições.xlsx");

            this.carregando = false;
        }).catch(error => {
            this.erro = "Nenhum resultado encontrado";
            this.carregando = false;
        });
    }

    onExportPdf = (filtro) => {
        this.carregando = true;
        this.erro = null;

        this.relatorioService.downloadAuditoriaSubstituicaoPdf(filtro).then(response => {
            fileDownload(response.data, "Auditoria substituições.pdf");

            this.carregando = false;
        }).catch(error => {
            this.erro = "Nenhum resultado encontrado";
            this.carregando = false;
        });
    }
}
